import { createModel, RematchDispatch } from '@rematch/core';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { fetchProjectItemsCms } from '../../services/projectItem';

export const storeName = 'projectItemEntity';

export const projectItemEntity = createModel<RootModel>()({
  name: storeName,
  state: { codes: {} },
  reducers: { ...baseEntity },
  effects: (dispatch: RematchDispatch<typeof projectItemEntity>) => ({
    async fetchProjectItem(payload) {
      const resp = await fetchProjectItemsCms(payload);
      if (!resp) return null;
      const { data } = resp;
      this.saves(data.content);
      return resp;
    },
  }),
});

export default projectItemEntity;
